/** Change Store module for Cart
 * Opens a modal window with the list of stores
*/
const storeLocator = require('../storeLocator/storeSelector');
const validation = require('../components/clientSideValidation');
const hoursTooltip = require('../components/hoursPopup');
const waiNotify = require('../components/waiNotify');

const $storeContainer = $('.js-shipping-form-group');
const notifications = {
    instoreDelivery: $storeContainer.data('action-message-store-selected'),
    homeDelivery: $storeContainer.data('action-message-home-selected'),
    doorDash: $('.js-doordash-name').eq(0).text().trim() + ' ' + $storeContainer.data('action-message-selected')
};

/**
 * init popup for close confirmation
 */
function initConfirmationClosePopup() {
    $(document.body).on('click.closeConfimation', (e) => {
        const $target = $(e.target);
        const $modal = $target.closest('.js-store-inventory-modal');
        const $modalContent = $target.closest('.js-store-inventory-modal-content');

        if ($modal.length && ($target.closest('.js-modal-close-btn').length || !$modalContent.length)) {
            window.dialogManager.closeAll();
        }

        if ($target.closest('.js-close-confirm-select').length) {
            window.dialogManager.closeAll();
            $(document.body).off('click.closeConfimation');
        }

        if ($target.closest('.js-cancel-close').length) {
            window.dialogManager.closeDialog();
        }
    });
}

/**
 * Generates the modal window on the first call.
 * @param {Object} $trigger - DOM node of button that triggered the modal. Need to return focus after close.
 * @param {Boolean} isDoorDash - Send for Door Dash modal only
 */
function getModalHtmlElement($trigger, isDoorDash) {
    if ($('#inStoreInventoryModal').length !== 0) {
        $('#inStoreInventoryModal').remove();
    }

    const htmlTemplate = $('#isp-modal-template').html();

    $('.b-page_inner').append(htmlTemplate);
    if (isDoorDash) {
        $('#inStoreInventoryModal').addClass('js-door-dash-store');
    }
    window.dialogManager.openDialog('panel', '#inStoreInventoryModal', $trigger);

    initConfirmationClosePopup();
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} actionURL - The product ID to search for
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElement(actionURL, pid, quantity, selectedPostalCode, selectedRadius) {
    const requestData = {
        products: `${pid} : ${quantity}`
    };

    const $modalBody = $('.js-store-modal-body');

    if (selectedRadius) {
        requestData.radius = selectedRadius;
    }

    if (selectedPostalCode) {
        requestData.postalCode = selectedPostalCode;
    }
    requestData.batch = '5';
    $('.js-store-locator-no-results').hide();

    $modalBody
        .attr('aria-busy', 'true').addClass('m-animated')
        .spinner().start(true);

    $.ajax({
        url: actionURL,
        data: requestData,
        method: 'GET',
        success: (response) => {
            $modalBody.empty()
                .attr('aria-busy', 'false')
                .removeClass('m-animated')
                .spinner().stop();

            $modalBody.html(response.storesResultsHtml);

            validation.init();
            storeLocator.search();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();
            storeLocator.expandStoresEvent('#inStoreInventoryModal');
            $('.btn-storelocator-search').attr('data-search-pid', pid);

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (selectedPostalCode && response.stores.length === 0) {
                $('.store-locator-no-results').show();
            }
        },
        error: () => {
            $modalBody.spinner().stop();
        }
    });
}
/**
 * @type {JQuery}
 */
var $activeTarget;

function showFindStorePopup(target, $trigger, isDoorDash) {
    const $target = $(target);
    const pid = $target.attr('data-pid');
    const quantity = $target.find('.js-line-item-qty').val();
    const actionURL = $target.data('inventoryUrl');

    getModalHtmlElement($trigger, isDoorDash);
    fillModalElement(actionURL, pid, quantity, '', '');
    $activeTarget = $target;
}

function updateStoreInCart(data, $storeElement) {
    const $cart = $('.js-cart');
    const actionURL = $storeElement.data('action-url');
    const pid = $storeElement.data('pid');
    const uuid = $storeElement.data('uuid');
    const $body = $('body');
    const $input = $storeElement.closest('.js-product-info').find('.js-line-item-qty');
    const quantity = $input.val();

    $cart.spinner().start();

    var requestData = {
        pid: pid,
        uuid: uuid,
        storeId: data.storeID,
        postalCode: data.postalCode || '',
        quantity
    };

    return $.ajax({
        url: actionURL,
        data: requestData,
        method: 'GET',
        success(data) {
            if (data.error) {
                window.window.location.href = data.redirectUrl;
            } else {
                $body
                    .trigger('basket:update:availability', { data, uuid })
                    .trigger('basket:validate', data)
                    .trigger('cart:update')
                    .trigger('basket:update:totals', data);

                $cart.spinner().stop();
            }
        },
        error(err) {
            if (err.responseJSON.redirectUrl) {
                window.window.location.href = err.responseJSON.redirectUrl;
            } else {
                let data = err.responseJSON,
                    uuid = err.responseJSON.items[0].UUID;

                err.responseJSON.isShowButton = true;

                $('body')
                    .trigger('basket:validate', err.responseJSON)
                    .trigger('basket:update:availability', { data, uuid })
                    .trigger('basket:update:totals', data.basket);

                $cart.spinner().stop();
            }
        }
    });

}

function getDoorDashModalHtmlElement($trigger, pid) {
    if ($('#doorDashModal').length !== 0) {
        $('#doorDashModal').remove();
    }
    const htmlTemplate = $('.js-door-dash-modal').html();
    $('.b-page_inner').append(htmlTemplate);

    window.dialogManager.openDialog('panel', '#doorDashModal', $trigger);
    $('#doorDashModal .js-door-dash-form').attr('data-pid', pid);
    initConfirmationClosePopup();
}

function showDoorDashModal(target, $trigger) {
    const $target = $(target);
    const pid = $target.attr('data-pid');
    getDoorDashModalHtmlElement($trigger, pid);
    $activeTarget = $target;
}

function removeSelectStoreClass(storeElement) {
    storeElement
        .parents('.js-shipping-form-group')
        .find('.js-selected-checkbox')
        .removeClass('js-selected-checkbox');
}

function addSelectStoreClass(storeElement, value) {
    storeElement
        .parents('.js-shipping-form-group')
        .find('.js-pickup-option[value="' + value + '"]')
        .addClass('js-selected-checkbox');
}

$('body').on('submit', '.js-door-dash-form', (e) => {
    e.preventDefault();
    $('.js-door-dash-error').hide();
    let spinner = $(e.target).spinner();
    spinner.start();
    let storeId = $('.js-selected-my-home-store').data('store-info').ID;
    let zipCode = $('.js-door-dash-form .js-store-postal-code').val();
    let productId = $('.js-door-dash-form').data('pid');
    let url = $('.js-select-door-dash').data('actionurl');
    let inStoreId = $('.js-door-dash-info').data('store-id') || $('.js-selected-product').find('.js-product-pickup-details').data('store-id');
    let storeObject = {
        postalcode: zipCode,
        storeNumber: inStoreId || storeId,
        productId: productId
    };
    $.ajax({
        url,
        type: 'get',
        dataType: 'json',
        data: storeObject,
        success(data) {
            if (data.isValidStore) {
                var storeData = {
                    storeID: storeObject.storeNumber,
                    postalCode: zipCode
                };
                var $storeElement = $('.js-door-dash-info').length > 0 ? $('.js-door-dash-info') : $('.js-selected-product').find('.js-product-detail');
                updateStoreInCart(storeData, $storeElement);
                window.dialogManager.closeDialog();
                removeSelectStoreClass($storeElement);
                addSelectStoreClass($storeElement, 'doorDash');
                $storeElement.removeClass('js-door-dash-info');
                if ($('.js-selected-product').length > 0) {
                    $('.js-selected-product').find('.js-empty-inventory').prop('checked', true);
                }
                $('.js-selected-product').removeClass('js-selected-product');
                waiNotify(notifications.doorDash);
                spinner.stop();
                $(document).off('click');
            } else {
                $('.js-door-dash-error').show();
                spinner.stop();
            }
        }
    });
});

function getStoreHTMLCart(data, $storeElement) {
    const productElement = $('.js-product-detail');
    const actionURL = $(productElement).data('getstore-url');

    var requestData = {
        storeId: data.storeID
    };

    return $.ajax({
        url: actionURL,
        data: requestData,
        method: 'GET',
        success(response) {
            //Render Store details
            $storeElement.empty();
            $storeElement.append(response);
            $storeElement.data('storeId', data.storeID);
            $storeElement.prop('hidden', false);
            $storeElement.show();
            $storeElement.find('.js-pickup-option[value="homeDelivery"]').prop('checked', false);
            $storeElement.find('.js-pickup-option[value="storePickup"]').prop('checked', true);
        }
    });

}
/**
 * Remove the selected store.
 * @param {HTMLElement} $container - the target html element
 */
function deselectStore($container) {
    const storeElement = $($container).find('.js-selected-store-with-inventory');
    $(storeElement).find('.js-selected-card-body').empty();
    $(storeElement).addClass('display-none');
    $($container).find('.js-btn-get-in-store-inventory').show();
}

module.exports = {
    init() {
        this.displayHours();
        this.changeStore();
        this.selectStoreAndUpdate();
        this.setHomeDelivery();
        this.setPickupInStore();
        this.setDoorDash();
        this.showSelectStoreModal();
    },
    removeSelectedStoreOnAttributeChange: () => {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            response.container.attr('data-pid', response.data.product.id);
            deselectStore(response.container);
        });
    },
    updateAddToCartFormData: () => {
        $('body').on('updateAddToCartFormData', (e, form) => {
            const $storeElement = $('.js-selected-store-with-inventory');
            if (form.pidsObj) {
                const pidsObj = JSON.parse(form.pidsObj);
                pidsObj.forEach((product) => {
                    product.storeId = $storeElement ? $storeElement.attr('data-store-id') : null;
                });

                form.pidsObj = JSON.stringify(pidsObj);
            }

            if ($storeElement.length) {
                form.storeId = $storeElement.attr('data-store-id');
            } else {
                form.storeId = null;
            }
        });
    },

    showInStoreInventory: () => {
        $('.js-btn-get-in-store-inventory').on('click', (e) => {
            const pid = $(e.currentTarget).closest('.js-product-detail').attr('data-pid');
            const quantity = $(e.currentTarget).closest('.js-product-detail').find('.quantity-select').val();
            getModalHtmlElement($(e.currentTarget));
            fillModalElement(pid, quantity);
            e.stopPropagation();
        });
    },
    selectStoreAndUpdate: () => {
        $('body').on('store:selected', (e, data) => {
            //Update the Store in Cart
            $('.js-select-store').addClass('js-store-has-been-selected');
            window.dialogManager.closeDialog();
            $('.js-cart-error').empty();
            $('#inStoreInventoryModal, #confirmCloseStoreSelect').remove();
            $(document.body).off('click.closeConfimation');
            const $storeElement = $($activeTarget).find('.js-product-detail');
            if (data && data.storeID) {
                let inStoreCheckbox = $storeElement.closest('.js-shipping-form-group').find('.js-pickup-option[value = "storePickup"]');
                inStoreCheckbox.prop('checked', true);
                removeSelectStoreClass($storeElement);
                addSelectStoreClass($storeElement, 'storePickup');
                updateStoreInCart(data, $storeElement).then(() => {
                    getStoreHTMLCart(data, $storeElement);
                    waiNotify(notifications.instoreDelivery);
                }).catch(() => {
                    getStoreHTMLCart(data, $storeElement);
                });
            }
            if (data.isDoorDash) {
                let item = $storeElement.closest('.js-product-info');
                let trigger = item.find('.js-empty-inventory');
                let doorData = {
                    item: item,
                    trigger: trigger
                };
                $('body').trigger('doordash:selected', doorData);
            }
        });
    },
    showSelectStoreModal: () => {
        $('body').on('door:selected', (e) => {
            e.preventDefault();
            let arg = $('.js-door-dash-info').closest('.js-product-info');
            const $button = $('.js-door-dash-info').find('.js-change-store');
            showFindStorePopup(arg, $button, true);
        });
    },
    setHomeDelivery: () => {
        $('body').on('homedelivery:selected', (event, itemElement, target) => {
            let storeData = { storeID: null };
            let $storeElement = $(itemElement || 'body').find('.js-product-detail');
            updateStoreInCart(storeData, $storeElement, target);
            waiNotify(notifications.homeDelivery);
        });
    },
    setPickupInStore: () => {
        $('body').on('pickupinstore:selected', (event, data) => {
            if (data.item) {
                showFindStorePopup(data.item, data.trigger);
            }
        });
    },
    setDoorDash: () => {
        $('body').on('doordash:selected', (event, data) => {
            if (data.item) {
                showDoorDashModal(data.item, data.trigger);
            }
        });
    },

    displayHours() {
        hoursTooltip.initHoursPopup();
    },

    changeStore: () => {
        $('body').on('click', '.js-change-store', ((e) => {
            e.preventDefault();
            const $button = $(e.currentTarget);
            showFindStorePopup($button.closest('.js-product-info'), $button);
        }));
    },

    selectCurrentStore() {
        $('body').on('click', '.js-select-current-store', ((e) => {
            e.preventDefault();
            var selectedStore = e.target.closest('.store-details');
            var data = {
                pid: $($activeTarget || 'body').find('.js-product-detail').attr('data-pid'),
                storeID: $(selectedStore).data('store-id'),
                storeDetailsHtml: $(selectedStore).html(),
                event: e
            };
            $('body').trigger('store:selected', data);
        }));
    }
};
